/**
 * @generated SignedSource<<d62921c3b3fd35f7d67fcc9db36c70d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WASignalOverviewQuery$variables = Record<PropertyKey, never>;
export type WASignalOverviewQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetOverviewSettings_Store">;
  };
};
export type WASignalOverviewQuery = {
  response: WASignalOverviewQuery$data;
  variables: WASignalOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WASignalOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetOverviewSettings_Store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WASignalOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a5dd625a8077e109a393369b859d9b7",
    "id": null,
    "metadata": {},
    "name": "WASignalOverviewQuery",
    "operationKind": "query",
    "text": "query WASignalOverviewQuery {\n  store {\n    ...WidgetOverviewSettings_Store\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetOverviewSettings_Store on Store {\n  publicTeams {\n    id\n    ...TeamSelectList_Team\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4730b17d3fe5dd75e2f607db98397d6";

export default node;
